import { render, staticRenderFns } from "./PrescriptManager.vue?vue&type=template&id=8065cfb8&"
import script from "./PrescriptManager.vue?vue&type=script&lang=ts&"
export * from "./PrescriptManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports